import React from "react";
import "@/styles/components/bundlePack.scss";
import ButtonComponent from "@/components/button/Button";
import { getIsLoggedIn, setCurrentForm, setModalOpen } from "@/reducers/commonSlice";
import { setCheckoutType, setIsCheckoutToShow, setProductData } from "@/reducers/checkoutSlice";
import { getProductData } from "@/services/common/getProductData";
import { getProducts } from "@/services/services/getProducts";
import SEOHead from "@/components/SEO/SEOHead";
import { Flex } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const BundlePack = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const dispatch = useDispatch();
  const handleNavigate = () => {
    const fetchProductData = isLoggedIn ? getProducts : getProductData;
    fetchProductData("PreApplication")
      .then((response) => {
        // Hardcoded need to change want work here
        const data = response.find((x) => x.id === 7);
        if (!data) {
          console.error("Product not found");
          return;
        } else {
          console.log(data, "data");
        }
        if (isLoggedIn) {
          dispatch(setCheckoutType(true));
          dispatch(setProductData(data));
          navigate("/checkout-preview");
        } else {
          dispatch(setModalOpen(true));
          dispatch(setCurrentForm("signIn"));
          dispatch(setCheckoutType(true));
          dispatch(setIsCheckoutToShow(true));
          dispatch(setProductData(data));
        }
      })
      .catch((error) => console.log(error));
  };

  // SEO metadata for Bundle Pack page
  const seoTitle = "Champions Bundle Pack | Comprehensive Study Abroad Package | Inforens";
  const seoDescription = "Get everything you need for your international education journey with our Champions Bundle Pack. Comprehensive support for applications, visas, and university preparation.";
  const seoKeywords = "champions bundle pack, study abroad package, international education bundle, university application package, visa preparation, Inforens bundle, education package";
  
  // Base URL for SEO tags
  const baseUrl = import.meta.env.VITE_URL || window.location.origin;
  const pageUrl = `${baseUrl}/inforens-champions-bundle-pack`;

  return (
    <>
      <SEOHead
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
        ogTitle={seoTitle}
        ogDescription={seoDescription}
        ogImage={`${baseUrl}/assets/images/champions-bundle-image.jpg`}
        ogUrl={pageUrl}
        ogType="product"
      />
      <div className="bundle-pack-wrapper">
        <h2 className="title title-h4 text-center">
          Unlock Your International Education Journey with the Champions Bundle
        </h2>
        <Flex align="center" justify="space-around" className="bundle-wrapper">
          <div className="content">
            <div className="body-b4-1">
              <b>The Ultimate Pack for Your Study Abroad Success!</b>
            </div>
            <li>
              Benefit from customized drafted SOPs, LORs, help in choosing universities and courses,
              and complete guidance throughout the process.
            </li>
            <div className="common-padd-top body-b4-1">
              <b>
                Scholarship applications along with university applications (no limit on number of
                university applications)
              </b>
            </div>
            <li>
              Assigned team support available at any point through quick chat and call scheduling
              lines.
            </li>
            <div className="common-padd-top body-b4-1">
              <b>IELTS /GRE/GMAT material available for prep</b>
            </div>
            <li>97% of students receive offer letters within 4 weeks.</li>
          </div>
          <div className="img-wrapper">
            <img src="/assets/images/sales.svg" />
          </div>
        </Flex>
        <div className="explore-button" style={{ marginTop: "15px", textAlign: "center" }}>
          <ButtonComponent varient="primary" label="Buy Now" onClick={handleNavigate} />
        </div>
        <Flex gap={"10px"} vertical>
          <div>
            <h2 className="title common-padd-top title-3 text-center" style={{ fontWeight: "500" }}>
              Get ready for an extraordinary journey filled with personalized guidance, unwavering
              support, and exciting opportunities.
            </h2>
            <div className="title title-h5 text-center" style={{ fontWeight: "500" }}>
              Champions Bundle Works in Two Phases
            </div>
            <label className="common-padd-top title-h6" style={{ fontWeight: "450" }}>
              Phase 1: Pre-Application Support
            </label>
            <div className="common-padd-top body-b2">
              Personalized Pre-Application Support Tailored to Your Dreams
            </div>
            <li>
              Connect with current students for invaluable insights and firsthand experiences at your
              desired universities.
            </li>
            <li>
              Receive individualized assistance in drafting an impressive CV, a compelling statement
              of purpose (SOP), and perfectly formatted Letters of Recommendation (LOR).
            </li>
            <li>Step-by-step guidance for a seamless application process.</li>
          </div>
          <div>
            <label
              className="common-padd-bottom common-padd-top title-h6"
              style={{ fontWeight: "450" }}
            >
              Phase 2: Post-Application Support
            </label>
            <div className="common-padd-top body-b2">
              Thriving Beyond Admissions: Unparalleled Support for Your Study Abroad Journey
            </div>
            <li>Part-time job assistance to unlock opportunities while studying.</li>
            <li>Expert help in securing suitable accommodations to ease housing stress.</li>
            <li>
              Dedicated mental support services to navigate cultural differences and challenges.
            </li>
            <li>
              In-person networking events to connect with fellow students at exciting party nights.
            </li>
            <li>
              Tap into an extensive network of current students and alumni for full-time job prospects
              and career guidance.
            </li>
          </div>
        </Flex>
        <div className="img-wrapper">
          <img src="/assets/images/shopping-cart.svg" />
        </div>
        <h2 className="title title-h4 common-padd-top text-center" style={{ fontWeight: "500" }}>
          Fulfill your dream of studying abroad by connecting with students
        </h2>
        <div className="body-b3">
          <b>The Ultimate Pack for Your Study Abroad Success!</b>
        </div>
        <Flex gap={"10px"} className="bullet-content">
          <div className="label">
            <b>Tailored Support:</b>
          </div>
          <div>Personalized assistance throughout your entire study abroad journey.</div>
        </Flex>
        <Flex gap={"10px"} className="bullet-content">
          <div>
            <b>Insider Knowledge:</b>
          </div>
          <div>Direct connections with current students for authentic insights.</div>
        </Flex>
        <Flex gap={"10px"} className="bullet-content">
          <div>
            <b>Comprehensive Services:</b>
          </div>
          <div>Support for both academic and non-academic aspects.</div>
        </Flex>
        <Flex gap={"10px"} className="bullet-content">
          <div>
            <b>Building Connections:</b>
          </div>
          <div>Establish a strong network of like-minded students and alumni.</div>
        </Flex>
        <Flex gap={"10px"} className="bullet-content">
          <div>
            <b>Success Made Easier:</b>
          </div>
          <div>Increase your chances of securing admissions and thriving in a new environment.</div>
        </Flex>
        <div className="explore-button" align="center" style={{ marginTop: "15px" }}>
          <ButtonComponent varient="primary" label="Buy Now" onClick={handleNavigate} />
        </div>
      </div>
    </>
  );
};

export default BundlePack;
